import {
  BiListCheck,
  FiUsers,
  BiPowerOff,
  BsClockHistory,
} from "react-icons/all";

// @material-ui/icons
import { CloudUploadRounded, PhotoLibrary, Storefront, Timeline, Folder, Category } from "@material-ui/icons";
import StockroomRouter from "./views/Stockroom/StockroomRouter";
import Users from "./views/Users/Users";
import SellerConfig from "./views/SellerConfig/SellerConfig";
import ProductImageUploader from "./views/ProductImages/ProductImageUploader";
import CSVUploader from "./views/CSVUploader/CSVUploader";
import EventTimeline from "./views/EventTimeline/EventTimeline";
import StoreHours from "./views/StoreHours";
import StorageBrowser from "./views/S3Browser/StorageBrowser";
import CategoryManagementRouter from "./views/CategoryManagement/CategoryManagementRouter";

var routes = [
  {
    path: "/stockroom",
    name: "Stockroom",
    icon: BiListCheck,
    component: StockroomRouter,
    layout: "/admin",
  },  
  {
    path: "/categories",
    name: "Category Management",
    icon: Category,
    component: CategoryManagementRouter,
    layout: "/admin",
    requiresGlobalAdmin: true,
  },
  {
    path: "/hours",
    name: "Store Hours",
    icon: BsClockHistory,
    component: StoreHours,
    bottom: true,
    layout: "/admin",
  },
  {
    path: "/images",
    name: "Product Images",
    icon: PhotoLibrary,
    component: ProductImageUploader,
    bottom: true,
    layout: "/admin",
    requiresGlobalAdmin: true,
  },
  {
    path: "/csv",
    name: "CSV Uploader",
    icon: CloudUploadRounded,
    component: CSVUploader,
    bottom: true,
    layout: "/admin",
    requiresGlobalAdmin: true,
  },
  {
    path: "/sellers",
    name: "Seller Config",
    icon: Storefront,
    component: SellerConfig,
    bottom: true,
    layout: "/admin",
    requiresGlobalAdmin: true,
  },
  {
    path: "/s3-browser",
    name: "S3 Browser",
    icon: Folder,
    component: StorageBrowser,
    layout: "/admin",
    requiresGlobalAdmin: true,
  },
  {
    path:"/events",
    name:"Pipeline Events",
    icon:Timeline,
    component:EventTimeline,
    bottom:true,
    layout: "/admin",
    requiresGlobalAdmin: true
  },
  {
    path: "/permissions",
    name: "Permissions",
    icon: FiUsers,
    component: Users,
    bottom: true,
    layout: "/admin",
    requiresUserManagementPermission: true,
  },
  {
    onClick: "logout",
    name: "Logout",
    icon: BiPowerOff,
    bottom: true,
    layout: "/admin",
  },
];

export default routes;
